import "./App.css";
import React, { useEffect } from "react";
import { MultiStepForm } from "../components/MultiStepForm";
// import "./index.css";

function App() {
  return (
    <div className="flex justify-center mx-auto" style={{ height: "40rem" }}>
      <MultiStepForm />
    </div>
  );
}

export default App;
